import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Button } from 'semantic-ui-react';
import agent from '../../../app/api/agent';
import { TemplateSubTasks } from '../../../app/models/template';
import { useStore } from '../../../app/stores/store';
import TaskFormModal from './TaskFormModal';
import { v4 as uuid } from 'uuid';
import { updateHistoryMain } from '../../../app/models/history';
import { Task } from '../../../app/api/types';

interface Props {
  activityId: string;
  currentTask: string;
}
function TaskandSubTask({ activityId, currentTask }: Props) {
  const {
    mediaAssetStore,
    activityStore,
    ElementStore,
    commonStore,
    userStore,
    viewStore: { viewPageHistory, activeOrder, assignedUsers },
  } = useStore();
  const {
    collectActiveSubTas,
    getActiveSubtaskInd,
    setSelectedTask,
    setSelectedSubTask,
  } = ElementStore;

  const [, setSubTasksEle] = useState<TemplateSubTasks[]>();
  const [, setActiveSubTasks] = useState<any>();
  const [, setShowSubtasksRow] = useState(false);
  const [showTasksModal, setShowTasksModal] = useState(false);
  const [eleModalTitle, setEleModalTitle] = useState<any>([]);
  const [subTaskIdNo, setSubTaskIdNo] = useState('');
  const [taskTitleName, setTaskTitleName] = useState('');
  const [, setSelectedSubTaskInd] = useState<any>();
  const [selectedSubTask, setSelectedSubtask] = useState<any>();
  const [taskId, setTaskId] = useState<string>();
  const [, setIsCurrTask] = useState<any>();
  const [sortedListItems, setSortedListItems] = useState<any>();
  const [listTaskItems, setListTaskItems] = useState<any>();
  const [currSubTaskData, setCurrSubTaskData] = useState<any>();
  const [, setTaskData] = useState<any>();
  const [taskIndex, setTaskIndex] = useState<any>();
  const [subTaskIndex, setSubTaskIndex] = useState(0);

  // useEffect(() => {
  //   getAssignedUsers({ itemId: activityId });
  //   // eslint-disable-next-line
  // }, [activityId]);

  useEffect(() => {
    setSortedListItems(activeOrder);
    const taskData = activeOrder?.tasks.filter((data: any) => {
      return data.isActive === true;
    });
    if (activeOrder.templateId !== '') {
      setListTaskItems(taskData);
    }
    // eslint-disable-next-line
  }, [activeOrder]);

  // useEffect(() => {
  //   if(mediaAssetStore.mediaAsset.editworkflow === "save") {
  //     sortedListItems?.forEach((data:any) => {
  //       toggledData.forEach((toggleDat: any) => {
  //         if(toggleDat.taskName === data.taskName){
  //           data.isActive = toggleDat.taskActive;
  //         }
  //       })
  //     })
  //   }
  //   // eslint-disable-next-line
  // },[mediaAssetStore.mediaAsset.editworkflow])

  const testtasksubtask = (
    task: Task,
    taskTitle: string,
    taskId: string,
    index: number,
    isCurrTask: boolean,
    subTaskName: string,
    subTaskId: string,
    subTaskData: any,
    subTaskIndex: number,
  ) => {
    setSubTaskIndex(subTaskIndex);
    setSubTasksEle(
      task.subTasks.sort((a: any, b: any) => {
        return a.subtaskIndex - b.subtaskIndex;
      }),
    );
    setActiveSubTasks(
      task.subTasks
        .filter(
          (data: TemplateSubTasks) =>
            data.isActive === true && data.isDeleted === false,
        )
        .sort((a: any, b: any) => a.subtaskIndex - b.subtaskIndex),
    );
    collectActiveSubTas(
      task.subTasks
        .filter(
          (data: TemplateSubTasks) =>
            data.isActive === true && data.isDeleted === false,
        )
        .sort((a: any, b: any) => a.subtaskIndex - b.subtaskIndex),
    );
    setTaskTitleName(taskTitle);
    setTaskData(sortedListItems);
    setTaskId(taskId);
    setTaskIndex(task.taskIndex);
    setShowSubtasksRow(true); //shows the row
    setIsCurrTask(isCurrTask);
    setSelectedTask(task);
    const modalTitle: string = ' / ' + currentTask + ' / ' + subTaskName;
    setEleModalTitle(modalTitle); //modal title
    setSelectedSubTaskInd(subTaskData.subtaskIndex);
    getActiveSubtaskInd(subTaskData.subtaskIndex);
    setSelectedSubtask(subTaskData);
    setSubTaskIdNo(subTaskId);
    // setSubTaskName(subTaskName);
    setShowTasksModal(true);
    setCurrSubTaskData(subTaskData);
    mediaAssetStore.setClickedTaskName(subTaskName);
    mediaAssetStore.simpleModalOpen(true);
    setSelectedSubTask(subTaskData); //selected Subtask
  };

  const closeTaskFormModal = (e: boolean) => {
    setShowTasksModal(false);
  };

  // const completeSubtask = async () => {
  //   const listTaskItemsDup: WorkFlowTask[] = Object.assign([], listTaskItems);
  //   let taskIndexTemp = taskIndex || 0;
  //   let subTaskIndexTemp = subTaskIndex || 0;
  //   let totalCompleteTaskCount = 0;

  //   mediaAssetStore.mediaAsset.subtaskCompleteDetails = {
  //     isLoading: true,
  //     id:
  //       listTaskItemsDup?.[taskIndexTemp]?.subTasks[subTaskIndexTemp]
  //         ?.subTaskId || '',
  //   };

  //   try {
  //     let payload = {
  //       templateId: sortedListItems?.templateId || '',
  //       itemId: activityId,
  //       taskId: listTaskItemsDup[taskIndexTemp].taskId,
  //       subtaskId:
  //         listTaskItemsDup[taskIndexTemp].subTasks[subTaskIndexTemp].subTaskId,
  //     };
  //     let p1 = new Promise(async (resolve) => {
  //       await agent.TaskFormTaskServices.updateCompleteSubTask(payload);
  //       resolve('');
  //     });

  //     p1.then(async () => {
  //       let activeTasks = listTaskItemsDup?.filter((data) => data.isActive);
  //       let activeSubtasks = activeTasks[
  //         activeTasks.length - 1
  //       ]?.subTasks?.flatMap((data) => (data.isActive ? data : []));
  //       for (let i = 0; i < listTaskItemsDup.length; i++) {
  //         if (listTaskItemsDup[i].status === 'completed') {
  //           totalCompleteTaskCount += 1;
  //         }
  //       }
  //       if (
  //         listTaskItemsDup[taskIndexTemp]?.taskId ===
  //           activeTasks[activeTasks.length - 1]?.taskId &&
  //         listTaskItemsDup[taskIndexTemp]?.subTasks[subTaskIndex]?.subTaskId ===
  //           activeSubtasks[activeSubtasks.length - 1]?.subTaskId
  //       ) {
  //         await Promise.all([
  //           agent.workflowStatus.updateWorkflowStatus({
  //             id: activityId,
  //             status: 'NA',
  //             current_task: 'NA',
  //             current_subtask: 'NA',
  //             isReceiving: false,
  //           }),
  //           // agent.workflowStatus.updateWorkflowInActive({
  //           //   itemId: id,
  //           //   templateId: payload.templateId,
  //           //   isActive: false
  //           // }),
  //           agent.workflowStatus.updateProductionCountThroughWF({
  //             itemId: activityId,
  //             totalTaskCount: listTaskItemsDup.length,
  //             totalCompleteTaskCount,
  //             isOrderComplete: true,
  //           }),
  //         ]);
  //       } else if (
  //         listTaskItemsDup[taskIndex].subTasks.length - 1 ===
  //         subTaskIndexTemp
  //       ) {
  //         await agent.workflowStatus.updateProductionCountThroughWF({
  //           itemId: activityId,
  //           totalTaskCount: listTaskItemsDup.length,
  //           totalCompleteTaskCount,
  //           isOrderComplete: false,
  //         });
  //       }
  //       activityStore.updateSchedule = true;
  //     })
  //       .then(() => {
  //         activityStore.updateSchedule = false;
  //         // toast.success("Task completed sucessfully");
  //         setTimeout(async () => {
  //           await getActiveOrder({ itemId: activityId });
  //           await getItemDetails({ itemId: activityId });
  //         }, 500);
  //       })
  //       .catch((error) => {
  //         mediaAssetStore.mediaAsset.subtaskCompleteDetails = {
  //           isLoading: false,
  //           id: '',
  //         };
  //         console.error(error);
  //       });
  //   } catch {
  //     mediaAssetStore.mediaAsset.subtaskCompleteDetails = {
  //       isLoading: false,
  //       id: '',
  //     };
  //   }
  // };

  const hideSubtask = (data: boolean) => {
    setShowSubtasksRow(data);
  };

  const workflowHistoryHandler = (
    elements: {
      id: any;
      description: string;
      values: string;
      type: string;
    }[],
    removedRow: any,
    addedRow: any,
    alteredRowHistory: any,
  ) => {
    function returntaskStatus(number: number) {
      switch (number) {
        case 0:
          return 'Yet to start';
        case 1:
          return 'Start';
        case 2:
          return 'Complete';
        case 3:
          return 'Hold';
        case 4:
          return 'Resume';
        case 5:
          return 'Reject';
        case 6:
          return 'Rework';
        case 7:
          return 'Resolve';
        default:
          return '';
      }
    }
    let updateHistory = new Promise(async (resolve, reject) => {
      elements?.forEach(async (element, index) => {
        let payload = {
          id: uuid(),
          itemId: activityId,
          taskId: listTaskItems[taskIndex].taskId,
          taskName: listTaskItems[taskIndex].taskName,
          subTaskName: selectedSubTask.subTaskName,
          subTaskId: selectedSubTask.subTaskId,
          elementName: element.description,
          elementValue: element.values?.toString()?.replaceAll(',', '|'),
          dateTime: new Date().toISOString(),
          status: returntaskStatus(selectedSubTask.status),
        };
        let name = '';
        if (element.values?.toString()?.split(',')?.[1]) {
          name = element.values?.toString()?.split(',')?.[1];
        } else {
          name = element.values?.toString()?.split(',')?.[0];
        }
        let status = '';
        if (element.type === 'AddFiles') {
          status = `uploaded file(s) under field "${element.description}" for`;
        } else if (element.type === 'AddPhotograph') {
          status = `uploaded photo(s) under field "${element.description}" for`;
        } else if (element.type === 'Users') {
          status = `updated field "${element.description}" to "${name}" for`;
        } else if (element.type === 'DynamicTable') {
          // status = `updated Dynamic table "${element.description}" for`
          if (removedRow[element.id]) {
            removedRow[element.id]?.forEach((data: any) => {
              delete data?.uuid;
              commonStore.updateHistoryAlonePOST(
                `${userStore.user?.displayName} removed record ${JSON.stringify(
                  data,
                )} from Dynamic table "${
                  element.description
                }" for ${activityStore.selectedActivity?.title}`,
                activityStore.selectedActivity?.id,
                undefined,
                false,
              );
            });
          }
          if (addedRow[element.id]) {
            addedRow[element.id]?.forEach((data: any) => {
              delete data?.uuid;
              commonStore.updateHistoryAlonePOST(
                `${userStore.user?.displayName} added record ${JSON.stringify(
                  data,
                )} to Dynamic table "${element.description}" for ${activityStore
                  .selectedActivity?.title}`,
                activityStore.selectedActivity?.id,
                undefined,
                false,
              );
            });
          }
          if (alteredRowHistory[element?.id]) {
            commonStore.updateHistoryAlonePOST(
              alteredRowHistory[element.id],
              activityStore.selectedActivity?.id,
              undefined,
              false,
            );
          }
        } else {
          status = `set "${element.description}" as "${name}" for`;
        }
        if (element.type !== 'DynamicTable') {
          const payload = {
            taskId: taskId || '',
            taskName: taskTitleName,
            subTaskId: selectedSubTask.subTaskId,
            subTaskName: selectedSubTask.subTaskName,
            status: status,
            date: new Date(),
          };
          updateHistoryMain(payload, true, false);
        }
        await agent.TaskFormTaskServices.updateComponentsValuesInHistory(
          payload,
        );
      });
      resolve('');
    });
    updateHistory.then(() => {
      let timer = setTimeout(() => {
        viewPageHistory({
          itemId: activityId,
          pageNo: 1,
          pageSize: 4,
        });
      }, 500);
      return () => clearTimeout(timer);
    });
  };

  const actionerNameHandler = (actionerName: string) => {
    let tasks = [...listTaskItems];
    if (tasks?.[taskIndex]?.subTasks?.[subTaskIndex]) {
      tasks[taskIndex].subTasks[subTaskIndex].actionerName = actionerName;
      setListTaskItems(tasks);
    }
  };

  return (
    <>
      {(mediaAssetStore.mediaAsset.editworkflow === 'save' ||
        mediaAssetStore.mediaAsset.editworkflow === 'cancel' ||
        mediaAssetStore.mediaAsset.editworkflow === 'close') &&
        listTaskItems !== undefined &&
        listTaskItems.map((data: Task, index: number) => {
          return (
            <>
              {data.taskName !== '' &&
                data.isActive === true &&
                data.isCurrentTask &&
                data.subTasks.map((a, subTaskIndex: number) => (
                  <>
                    {a.isActive === true &&
                      a.subTaskName !== '' &&
                      data.isActive === true &&
                      a.isCurrentSubtask === true && (
                        <Button
                          color="teal"
                          className="current_task"
                          key={data.taskId}
                          onClick={() =>
                            testtasksubtask(
                              data,
                              data.taskName,
                              data.taskId,
                              index,
                              data.isCurrentTask,
                              a.subTaskName,
                              a.subTaskId,
                              a,
                              subTaskIndex,
                            )
                          }
                        >
                          {data.taskName} / {a.subTaskName}
                        </Button>
                      )}
                  </>
                ))}
            </>
          );
        })}
      {showTasksModal ? (
        <TaskFormModal
          taskname={taskTitleName}
          showTasksModal={showTasksModal}
          closeTaskFormModal={closeTaskFormModal}
          assignedUsers={assignedUsers}
          selectedSubTask={selectedSubTask}
          eleModalTitle={eleModalTitle}
          subTaskIdNo={subTaskIdNo}
          // filterRolesHandler={filterRolesHandler}
          taskData={sortedListItems}
          taskId={taskId}
          currSubTaskData={currSubTaskData}
          hideSubtask={hideSubtask}
          actionerNameHandler={actionerNameHandler}
          workflowHistoryHandler={workflowHistoryHandler}
        />
      ) : null}
    </>
  );
}

export default observer(TaskandSubTask);
